import type { RouterConfig } from '@nuxt/schema';

export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    // RIMUOVE SCROLL AUTOMATICO AL CAMBIO PAGINA PD!!!
    const nuxtApp = useNuxtApp();

    nuxtApp.hook('page:transition:finish', () => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    });
    return false;
  },
};
